import React from 'react';

const UploadContext = React.createContext({});

export const UploadProvider = UploadContext.Provider;

export default UploadContext;
